// Markers on the drawn network maps (website network page and /n) are
// placed by their real coordinates, so a trailhead and the parking lot
// across the road land on top of each other and one sign hides the
// other. This nudges overlapping markers apart just far enough to read
// both, and leaves every marker that has room exactly where it is.
//
// Each marker is a box: { x, y, w, h } in the drawing's own units,
// centered on (x, y). The result is a new { x, y } per marker, in the
// same order, plus `moved` so the caller can draw a short tie back to
// the true spot.
//
// Pairs are pushed apart along whichever axis needs the smaller move,
// a few rounds over, so a cluster of three settles too. Markers stay
// inside `bounds` when given.

export function declutter(markers, { gap = 4, rounds = 24, bounds = null } = {}) {
    const pts = markers.map((m) => ({ x: m.x, y: m.y, w: m.w, h: m.h, x0: m.x, y0: m.y }));
    const clamp = (p) => {
        if (!bounds) return;
        p.x = Math.min(bounds.x1 - p.w / 2, Math.max(bounds.x0 + p.w / 2, p.x));
        p.y = Math.min(bounds.y1 - p.h / 2, Math.max(bounds.y0 + p.h / 2, p.y));
    };
    for (let r = 0; r < rounds; r++) {
        let moved = false;
        for (let i = 0; i < pts.length; i++) {
            for (let j = i + 1; j < pts.length; j++) {
                const a = pts[i], b = pts[j];
                const ox = (a.w + b.w) / 2 + gap - Math.abs(a.x - b.x);
                const oy = (a.h + b.h) / 2 + gap - Math.abs(a.y - b.y);
                if (ox <= 0 || oy <= 0) continue;
                moved = true;
                // Two markers on the very same spot: split them sideways,
                // the earlier one to the left, so the result is stable.
                if (ox <= oy) {
                    const dir = a.x < b.x || (a.x === b.x && i < j) ? -1 : 1;
                    a.x += dir * ox / 2;
                    b.x -= dir * ox / 2;
                } else {
                    const dir = a.y < b.y ? -1 : 1;
                    a.y += dir * oy / 2;
                    b.y -= dir * oy / 2;
                }
                clamp(a);
                clamp(b);
            }
        }
        if (!moved) break;
    }

    return pts.map((p) => ({
        x: p.x,
        y: p.y,
        moved: Math.hypot(p.x - p.x0, p.y - p.y0) > 0.5,
        x0: p.x0,
        y0: p.y0,
    }));
}
